var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#B2D9FC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 23.8C28 23.8 30.4 21.4 30.4 18.4C30.4 15.4 28 13 25 13C22 13 19.6 15.4 19.6 18.4C19.6 21.4 22 23.8 25 23.8ZM25 15C26.9 15 28.4 16.5 28.4 18.4C28.4 20.3 26.9 21.8 25 21.8C23.1 21.8 21.6 20.3 21.6 18.4C21.6 16.5 23.1 15 25 15Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2 25.4H22.8C17.9 25.4 14 29.4 14 34.2C14 34.8 14.4 35.2 15 35.2C15.6 35.2 16 34.8 16 34.2C16 30.4 19.1 27.4 22.8 27.4H27.2C31 27.4 34 30.5 34 34.2C34 34.8 34.4 35.2 35 35.2C35.6 35.2 36 34.8 36 34.2C36 29.4 32 25.4 27.2 25.4Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.7bbe22ae01b9a925626afe20856366e2.svg";
export { ForwardRef as ReactComponent };